<script setup lang="ts">
import RAction from '../../../base/RAction/index.vue'
import { ElScrollbar } from 'element-plus'
import { gifts2Play, showGiftPlay, tryGetGifts, useGiftStore, type GiftCategory } from '@/composables/memorize/gift'
// Import Swiper Vue.js componentsç
import { Swiper, SwiperSlide } from 'swiper/vue'
// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
// import required modules
import { Pagination } from 'swiper/modules'
import type { Swiper as SwiperType } from 'swiper'
import { computed, onMounted, nextTick, type PropType, type Ref, ref, toRaw, watch } from 'vue'
import {
  createMemorialMessage,
  reloadAddMemory,
  type CreateMemorialMessageBody,
  type MemorialGiftDTO,
  type MemorialMessageDTO,
  type PreloadAddMemoryResponse,
  type Tag
} from '@/composables/memorize/memorize'
import { useRouter, useRoute } from 'vue-router'
import { currentLang } from '@/composables/settings/storage'
import GiftItem from '../../../business/media/GiftItem.vue'
import { tryGetCoinAccount, useCoinStore } from '@/composables/coin/coin'
import { handleErr } from '@/composables/exception/handler'
import type { CommonResponse } from '@/apis/api'
import { CODE_BALANCE_NOT_ENOUGH, CODE_OK } from '@/apis/code'
import { isNotEmpty, renderMessage } from '@/utils/util'
import beanImg from '@/assets/bean_colored.svg'
import 'animate.css'
import { ElMessage } from 'element-plus'
import type { PaginationOptions } from 'swiper/types/modules/pagination'
// import { LazyImg } from 'vue-waterfall-plugin-next'
import { isSetRealName, isLogin } from '@/composables/user/users'
import SetRealNameDialog from '@/components/business/me/SetRealNameDialog.vue'
import { currentUser } from '@/composables/user/users'

const realNameModalRef = ref<InstanceType<typeof SetRealNameDialog> | null>(null)

const router = useRouter()
const route = useRouter().currentRoute.value
const store = useGiftStore()

const coinStore = useCoinStore()

const selectedItem = ref<MemorialGiftDTO | undefined>()

const model = defineModel<boolean>()

const currentSlide = ref(0)

const isOther = ref(false)

const props = defineProps({
  serviceId: {
    type: String,
    default: ''
  },
  initCategory: {
    type: [String, null] as PropType<string | null>,
    default: null
  },
  initId: {
    type: [String, null] as PropType<string | null>,
    default: null
  },
  altarId: {
    type: String,
    default: null,
    required: false
  },
  giftId: {
    type: String,
    default: null,
    required: false
  },
  freeFlowerOnly: {
    type: Boolean,
    default: false
  }
})

const altarId = computed(() => props.altarId)
const freeFlowerOnly = computed(() => props.freeFlowerOnly === true)

const selectedCategory: Ref<string> = ref('flower')

onMounted(() => {
  tryGetGifts()
  tryGetCoinAccount()
})

const tags: Ref<Array<Tag>> = ref([])
async function prepareData(serviceId: string) {
  const { data, error, statusCode } = await reloadAddMemory(serviceId)
  if (error.value) {
    handleErr(data, error, statusCode)
  } else {
    const resData = data as Ref<CommonResponse<PreloadAddMemoryResponse>>
    if (resData.value.code === CODE_OK) {
      // success
      console.log('resData.value.anniversaries:', resData.value.data.anniversaries)
      if (tags.value.length == 0) {
        resData.value.data.anniversaries.forEach((element) => {
          console.log('element.anniversaryDate:', element.anniversaryDate)
          const year = element.anniversaryDate
            ? new Date(element.anniversaryDate).getFullYear()
            : new Date().getFullYear()
          tags.value.push({ key: 'a_' + element.id, name: year + ' ' + element.anniversaryName })
        })
      }
    } else {
      ElMessage({
        message: renderMessage(resData.value.message),
        type: 'warning'
      })
    }
  }
}

function onItemSelect(item: MemorialGiftDTO) {
  console.log('111', item)
  selectedItem.value = item
  topupTipsShow.value = false
}

const groupedGifts = computed(() => {
  const result: MemorialGiftDTO[][] = []
  if (store.getGiftList && store.getGiftList.length > 0) {
    const itemsPerPage = 8
    const filteredGifts = store.getGiftList.filter((gift) => {
      if (!gift.categories.includes(selectedCategory.value)) return false
      if (freeFlowerOnly.value) return gift.price === 0
      return true
    })
    for (let i = 0; i < filteredGifts.length; i += itemsPerPage) {
      result.push(filteredGifts.slice(i, i + itemsPerPage))
    }
    if (
      !route.query.giftId ||
      preSelectGiftCategories.value !== selectedCategory.value ||
      chooseOtherCategory.value === true
    ) {
      selectedItem.value = filteredGifts[0]
      console.log('这里修改了selectedItem.value = filteredGifts[0]')
    }
  }
  return result
})

const childrenGifts = computed(() => {
  const result: MemorialGiftDTO[][] = []
  if (
    store.getGiftList &&
    store.getGiftList.length > 0 &&
    selectedItem.value.pack &&
    selectedItem.value.idsInPack?.length > 0
  ) {
    const itemsPerPage = 12
    const filteredGifts = store.getGiftList.filter((gift) => selectedItem.value.idsInPack.includes(gift.id))
    for (let i = 0; i < filteredGifts.length; i += itemsPerPage) {
      result.push(filteredGifts.slice(i, i + itemsPerPage))
    }
  }
  return result
})

const selectedPackPrice = computed(() => {
  if (selectedItem.value.pack) {
    const price = selectedItem.value.idsInPack?.reduce((acc, cur) => {
      const gift = store.getGiftList.find((gift) => gift.id === cur)
      return acc + gift.price
    }, 0)
    return price
  }
  return selectedItem.value.price
})

const chooseOtherCategory = ref(false)

watch(freeFlowerOnly, (val) => {
  if (!val) return
  selectedCategory.value = 'flower'
  isOther.value = false
  chooseOtherCategory.value = false
  currentSlide.value = 0
})

function onCategorySelected(key: string) {
  selectedCategory.value = key
  chooseOtherCategory.value = true
  topupTipsShow.value = false

  // 依据新分类下礼物数量计算页数（每页 8 个）
  const itemsPerPage = 8
  const filteredGifts =
    store.getGiftList?.filter((gift) => {
      if (!gift.categories.includes(selectedCategory.value)) return false
      if (freeFlowerOnly.value) return gift.price === 0
      return true
    }) || []
  const pagesCount = Math.max(1, Math.ceil(filteredGifts.length / itemsPerPage))

  // 如果当前页超出新分类页数，则切到第一页，否则保持当前页
  if (currentSlide.value >= pagesCount) {
    currentSlide.value = 0
  }
  mainSwiper.value?.slideTo(currentSlide.value)

  // 子面板始终重置到第一页
  childrenSwiper.value?.slideTo(0)

  // 强制重新生成 slides，避免空白页
  mainSwiperKey.value++
  childrenSwiperKey.value++
}

const onTopup = () => {
  topupTipsShow.value = false
  model.value = false
  router.push('/wallet?topup=true')
}

const topupTipsShow = ref(false)

const mainCategories = computed(() => {
  const categories = store.getCategories
    ?.filter((item) => {
      return item.main && !item.hide
    })
    .sort((a, b) => {
      return a.rank - b.rank
    })
  if (freeFlowerOnly.value) {
    return categories?.filter((item) => item.value.key === 'flower')
  }
  return categories
})
const otherCategories = computed(() => {
  if (freeFlowerOnly.value) return []
  return store.getCategories
    ?.filter((item) => {
      return !item.main && !item.hide
    })
    .sort((a, b) => {
      return a.rank - b.rank
    })
})

const emit = defineEmits(['sent', 'redirectToLogin'])
const preSelectGiftCategories = ref('')
// 查找礼物并选中对应的分类和礼物
const findAndSelectGift = (giftId: string) => {
  if (!giftId || !store.getGiftList || store.getGiftList.length === 0) return false

  const gift = store.getGiftList.find((item) => item.id === giftId)
  preSelectGiftCategories.value = gift.categories[0]
  console.log('找到了礼物，礼物信息:', gift)
  if (gift) {
    // 找到礼物后，设置其分类并选中
    if (gift.categories && gift.categories.length > 0) {
      console.log('当前礼物列表已经加载完毕:', gift)

      const category = gift.categories[0]
      selectedCategory.value = category

      // 查找礼物所在的分页位置
      const filteredGifts = store.getGiftList.filter((g) => g.categories.includes(category))
      const giftIndex = filteredGifts.findIndex((g) => g.id === giftId)
      const itemsPerPage = 8
      const pageIndex = Math.floor(giftIndex / itemsPerPage)

      // 设置当前页和选中的礼物
      currentSlide.value = pageIndex
      onItemSelect(gift)
      console.log('设置当前页和选中的礼物:', currentSlide.value, selectedItem.value)
      // 检查是否为其他分类
      const isMainCategory = mainCategories.value.some((c) => c.value.key === category)
      isOther.value = !isMainCategory

      // 强制重置主 Swiper，防止分页器状态残留
      mainSwiperKey.value++
      // 如果是礼包，强制刷新子 Swiper
      if (gift.pack) {
        childrenSwiperKey.value++
      }

      // 滑动到对应页面
      setTimeout(() => {
        mainSwiper.value?.slideTo(pageIndex)
      }, 100)

      return true
    }
  }
  return false
}

watch(
  model,
  (newVal) => {
    if (newVal) {
      // 默认选择花类别
      selectedCategory.value = 'flower'

      // 如果有指定分类，则使用指定分类
      if (isNotEmpty(props.initCategory)) {
        selectedCategory.value = props.initCategory
        currentSlide.value = 0
        mainSwiperKey.value++
        childrenSwiperKey.value++
      }

      console.log('serviceId changed:', props.serviceId)
      if (props.serviceId && props.serviceId !== null) {
        prepareData(props.serviceId)
      }

      // 检查URL或props中是否有giftId参数
      const urlGiftId = route.query.giftId as string
      const giftIdToUse = props.giftId || urlGiftId

      if (giftIdToUse) {
        // 等待礼物列表加载完成
        if (store.getGiftList && store.getGiftList.length > 0) {
          // 尝试查找并选中礼物
          console.log('url中有id，开始寻找')
          const found = findAndSelectGift(giftIdToUse)
          if (!found) {
            // 如果没找到，使用默认选择逻辑
            console.log('没有找到礼物，使用默认选择逻辑')
            const filteredGifts =
              store.getGiftList?.filter((gift) => gift.categories.includes(selectedCategory.value)) || []
            selectedItem.value = filteredGifts[0]
            currentSlide.value = 0
          }
        } else {
          // 如果礼物列表尚未加载，设置一个监听器
          const unwatch = watch(
            () => store.getGiftList,
            (newList) => {
              if (newList && newList.length > 0) {
                findAndSelectGift(giftIdToUse)
                unwatch() // 找到后取消监听
              }
            },
            { deep: true }
          )
        }
      } else {
        console.log('没有id，使用默认选择逻辑')
        // 默认选中当前分类下的第一个礼物
        const filteredGifts =
          store.getGiftList?.filter((gift) => gift.categories.includes(selectedCategory.value)) || []
        selectedItem.value = filteredGifts[0]
        currentSlide.value = 0
      }

      mainSwiper.value?.slideTo(currentSlide.value)
      childrenSwiper.value?.slideTo(0)
    }
  },
  { immediate: true }
)

async function onSendGift() {
  if (!isSetRealName.value) {
    const isSuccess = await realNameModalRef.value?.open()
    if (!isSuccess) {
      console.log('用户取消了实名认证，停止后续操作')
      return
    }
  }
  if (selectedItem.value.price > 0 && coinStore.getCoin() < selectedItem.value.price) {
    topupTipsShow.value = true
    return
  }
  preCreateMessage()
}

async function preCreateMessage() {
  const body = {
    serviceId: props.serviceId,
    giftId: selectedItem.value.id,
    content: '',
    relationCode: null,
    relationName: null,
    tags: toRaw(tags.value),
    msgType: 1 // 0-留言 1-礼品
  } as CreateMemorialMessageBody
  const { data, error, statusCode } = await createMemorialMessage(body)
  console.log('create life:', data.value, error.value, statusCode.value)
  tryGetCoinAccount()
  if (error.value) {
    handleErr(data, error, statusCode)
  } else {
    const resData = data as unknown as Ref<CommonResponse<MemorialMessageDTO>>
    if (resData.value.code === CODE_OK) {
      // success
      console.log('create gift success')
      emit('sent')
      if (!selectedItem.value.pack) {
        // 单只礼物
        gifts2Play.value.splice(0, gifts2Play.value?.length || 0, selectedItem.value)
      } else {
        // 礼包
        const filteredGifts = store.getGiftList.filter((gift) => selectedItem.value.idsInPack.includes(gift.id))
        // insert selectedItem to filteredGifts's first
        filteredGifts.splice(0, 0, selectedItem.value)
        gifts2Play.value.splice(0, gifts2Play.value?.length || 0, ...filteredGifts)
      }
      model.value = false
      setTimeout(() => {
        showGiftPlay.value = true
      }, 500)
    } else {
      if (resData.value.code === CODE_BALANCE_NOT_ENOUGH) {
        topupTipsShow.value = true
      } else {
        ElMessage({
          message: renderMessage(resData.value.message),
          type: 'warning'
        })
      }
    }
  }
}

function onClose() {
  model.value = false
  topupTipsShow.value = false
}

function onMainCategoryClick(category: GiftCategory) {
  if (freeFlowerOnly.value && category.value.key !== 'flower') return
  isOther.value = false
  onCategorySelected(category.value.key)
}

function onOtherCategoryClick() {
  if (freeFlowerOnly.value) return
  if (!isOther.value) {
    const key = otherCategories.value.find((item) => item.rank >= 0)?.value?.key
    isOther.value = true
    if (key) onCategorySelected(key)
  }
}

const mainSwiper = ref<SwiperType | null>(null)
const childrenSwiper = ref<SwiperType | null>(null)
// 通过 key 强制重建 Swiper，以在数据变化时重置 slides
const mainSwiperKey = ref(0)
const childrenSwiperKey = ref(0)

function onMainSwiperInit(swiper: SwiperType) {
  mainSwiper.value = swiper
}

function onChildrenSwiperInit(swiper: SwiperType) {
  childrenSwiper.value = swiper
}

const mainPaginationConfig = {
  enabled: true,
  clickable: true
} as any

const childrenPaginationConfig = {
  enabled: true,
  clickable: true
} as any

const isMember = computed(() => {
  return currentUser.value?.member !== null && currentUser.value?.member.state === 1
})

const textContainerRef = ref<HTMLElement | null>(null)
const isSmallText = ref(false)

watch(
  () => selectedItem.value?.words?.data[currentLang.value],
  () => {
    isSmallText.value = false
    nextTick(() => {
      // 48px is a safe threshold for 1 line (approx 46px) vs 2 lines (>60px)
      if (textContainerRef.value && textContainerRef.value.offsetHeight > 48) {
        isSmallText.value = true
      }
    })
  },
  { immediate: true, flush: 'post' }
)
</script>
<template>
  <RAction v-model="model" :fromBottom="true">
    <div v-if="!selectedItem?.pack && selectedItem?.price > 0" w-full flex="~ col" items-center>
      <div w-80 h-80 my-6>
        <transition name="fade" mode="out-in">
          <RLazyImage :key="selectedItem?.id" :src="selectedItem?.file?.middleQuality" />
        </transition>
      </div>
    </div>
    <!-- 2級禮物面板 -->
    <transition
      enter-active-class="slide-from-bottom-enter-active"
      leave-active-class="slide-from-bottom-leave-active"
      mode="out-in">
      <div
        v-if="selectedItem?.pack"
        rounded-2
        w-full
        flex="~ col"
        max-w-400
        overflow-hidden
        select-none
        pt-4
        pb-2
        mb-1px
        :class="selectedPackPrice <= 1000 ? 'bg-light-gray-gradient' : 'bg-green-gradient'">
        <h2 pl-6 mb-1.5 text-sm text-main>
          {{ $t('gift.pack_details', { count: selectedItem?.idsInPack?.length || 0, coin: selectedPackPrice }) }}
        </h2>
        <div pl-6 mb-2 text-3 text-green-6>
          {{ $t('gift.pack_anim_duration', { s: selectedItem?.idsInPack?.length * 5 }) }}
        </div>
        <ClientOnly>
          <swiper
            :key="childrenSwiperKey"
            @swiper="onChildrenSwiperInit"
            :slides-per-view="1"
            :pagination="childrenPaginationConfig"
            :modules="[Pagination]"
            :initial-slide="0"
            w-full>
            <swiper-slide w-full v-for="(slide, slideIndex) in childrenGifts" :key="slideIndex">
              <div w-full h-42 px-3 pb-6 grid grid-cols-6 gap-1 items-start justify-center>
                <div
                  v-for="item in slide"
                  relative
                  w-full
                  min-h-16
                  flex="~ col"
                  items-center
                  justify-start
                  :key="item.id"
                  cursor-pointer
                  class="hover:bg-white/80"
                  rounded
                  active:border-primary>
                  <GiftItem :gift="item" :isPreview="false" :size="9.5" p-1 mt-1 />
                  <div w-full text-center text-main text-xs rounded overflow-hidden pb-1 px-0.3 truncate>
                    {{ item.giftNames.data[currentLang] }}
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </ClientOnly>
      </div>
    </transition>
    <!-- header -->
    <div
      z-1
      w-full
      flex="~ col"
      max-w-400
      class="safe-padding"
      bg-white
      rounded-t-2
      md:rounded-2
      md:overflow-hidden
      select-none>
      <div relative w-full pt-3 pb-4>
        <div flex="~ row" w-full justify-center>
          <div
            v-for="(item, index) in mainCategories"
            @click="onMainCategoryClick(item)"
            :key="index"
            text-lg
            py-1
            px-2
            :class="{
              'text-primary font-bold': !isOther && selectedCategory === item.value.key,
              'max-w-18': currentLang.startsWith('zh'),
              'max-w-30': currentLang.startsWith('en')
            }">
            {{ item.value.data[currentLang] }}
          </div>
          <div
            v-if="!freeFlowerOnly"
            text-lg
            py-1
            px-2
            :class="{
              'text-primary font-bold': isOther,
              'max-w-18': currentLang.startsWith('zh'),
              'max-w-30': currentLang.startsWith('en')
            }"
            @click="onOtherCategoryClick">
            {{ $t('gift.other') }}
          </div>
        </div>
        <div
          i-material-symbols-light:close
          absolute
          right-2
          top-2
          text-third
          text-xl
          p-1
          icon-button
          @click="onClose"></div>
      </div>
      <!-- 子分类 -->
      <el-scrollbar v-if="isOther" wrap-class="custom-scrollbar-wrap">
        <div w-full flex="~ row" mb-3 px-4 relative>
          <div
            py-1
            min-w-12
            text-center
            px-1
            shrink-0
            text-sm
            v-for="(category, index) in otherCategories"
            :class="{
              'text-primary font-bold': selectedCategory === category.value.key,
              'max-w-17': currentLang.startsWith('zh'),
              'max-w-20': currentLang.startsWith('en')
            }"
            @click="onCategorySelected(category.value.key)"
            truncate>
            {{ category.value.data[currentLang] }}
          </div>
          <div
            v-if="selectedCategory == 'traditional' && altarId != null"
            @click="$router.push('/altar/' + altarId)"
            absolute
            right-4
            top-0
            py-1
            px-1
            link
            text-sm
            text-primary-active
            bg-base>
            {{ $t('altar.altar') }}&gt;
          </div>
        </div>
      </el-scrollbar>
      <!-- 礼物 -->
      <ClientOnly>
        <swiper
          :key="mainSwiperKey"
          @swiper="onMainSwiperInit"
          :slides-per-view="1"
          :pagination="mainPaginationConfig"
          :modules="[Pagination]"
          :initial-slide="currentSlide"
          w-full>
          <swiper-slide w-full v-for="(slide, slideIndex) in groupedGifts" :key="slideIndex">
            <div w-full h-56 px-6 grid grid-cols-4 gap-1 items-start justify-center>
              <div
                v-for="item in slide"
                relative
                w-full
                min-h-22
                flex="~ col"
                items-center
                justify-start
                :key="item.id"
                cursor-pointer
                hover:border-light-strong
                class="hover:bg-gray-100/50"
                border-white
                border-1.5
                rounded
                :class="{ '!border-primary bg-gray-100': item.id === selectedItem?.id }"
                active:border-primary>
                <GiftItem :gift="item" :isPreview="false" @click="onItemSelect(item)" p-1 mt-1 />
                <div w-full text-center text-second text-xs rounded overflow-hidden pb-1 px-1 truncate>
                  {{ item.giftNames.data[currentLang] }}
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </ClientOnly>
      <!-- <div w-full pl-6 pr-6 mt-1>
        <p text-sm text-second bg-grey p-3 rounded-2 leading-5 flex="~ row" items-center>
          {{ selectedItem?.words?.data[currentLang] || $t('gift.no_greeting') }}
        </p> 
        <p text-sm text-second class="bg-amber-100/60 border-amber-100 border-1px" p-3 rounded-2 leading-5 flex="~ row"
          items-center>
          <span :key="selectedItem?.words?.data[currentLang] || $t('gift.no_greeting')" text-left>{{
            selectedItem?.words?.data[currentLang] || $t('gift.no_greeting')
            }}</span>
        </p>
      </div> -->
      <div v-if="!freeFlowerOnly" flex="~ row" items-baseline py-2 pl-6 pr-6 w-full text-sm>
        <div>
          {{ $t('gift.panel_coin_balance') }}<span>{{ coinStore.getCoin() }}</span>
        </div>
        <div grow pl-2>
          <el-popover :visible="topupTipsShow" placement="top" effect="dark" :width="200" trigger="click" content="">
            <template #reference>
              <span btn-hint style="color: #a27a2e" text-sm hover:text-primary-active py-2 px-4 @click="onTopup">{{
                $t('action.topup')
              }}</span>
            </template>
            <div flex="~ row" items-start>
              <p text-revert text-sm grow>{{ $t('gift.panel_coin_not_enough') }}</p>
              <div
                i-material-symbols-light:close
                text-third
                text-lg
                @click="topupTipsShow = false"
                hover:text-second
                cursor-pointer></div>
            </div>
          </el-popover>
        </div>
        <div v-if="selectedItem?.price != 0 || !isMember" :class="isMember ? 'text-black ' : ''">
          <span v-if="isMember" text-second>{{ $t('member.not_member') }}</span>
          <span v-if="isMember" class="line-through ml-2 text-second">{{
            $t('member.coin_price', { coin: selectedItem?.price })
          }}</span>
          <span v-if="!isMember" style="color: #b69860" class="underline" @click="router.push('/member')">{{
            $t('member.member_price')
          }}</span>
        </div>
      </div>
      <div flex="~ row" w-full py-3 pt-1 pl-6 pr-6 mb-1>
        <div class="w-11/18" mr-2>
          <div
            ref="textContainerRef"
            :class="isSmallText ? 'text-xs' : 'text-sm'"
            text-second
            class="bg-amber-100/60 border-amber-100 border-1px"
            p-3
            rounded-2
            leading-5
            text-left
            :key="selectedItem?.words?.data[currentLang] || $t('gift.no_greeting')">
            {{ selectedItem?.words?.data[currentLang] || $t('gift.no_greeting') }}
          </div>
        </div>
        <button
          shrink
          :class="
            (currentLang.startsWith('zh') ? 'max-w-35 ' : 'max-w-44 ') +
            (isMember
              ? 'btn-solid  bg-member hover:bg-member-active active:bg-member-active duration-200 disabled:bg-member-light disabled:text-member'
              : 'btn-solid')
          "
          grow
          py-2.5
          px-2.5
          rounded-2
          @click="onSendGift"
          flex="~ row"
          justify-center
          items-center>
          {{
            (selectedItem?.price || 0) > 0
              ? isMember
                ? (selectedItem?.memberPrice || 0) + ' ' + $t('coin.multiple')
                : (selectedItem?.price || 0) + ' ' + $t('coin.multiple')
              : $t('coin.send_for_free')
          }}
          <img v-if="(selectedItem?.price || 0) > 0" :src="beanImg" w-4 h-4 ml-1 mt-0.5 />
        </button>
      </div>
    </div>
  </RAction>
  <SetRealNameDialog ref="realNameModalRef" />
</template>
<style lang="scss">
.el-scrollbar__bar {
  &.is-horizontal {
    display: none;
  }

  &.is-vertical {
    display: none;
  }
}

.el-scrollbar__wrap {
  &::-webkit-scrollbar {
    display: none;
    /* Chrome, Safari, Edge, Opera */
  }

  scrollbar-width: none;
  /* Firefox */
}

/* 自定义进入动画 */
.slide-from-bottom-enter-active {
  animation: slide-from-bottom-enter 0.5s ease-out;
}

@keyframes slide-from-bottom-enter {
  from {
    transform: translateY(100%);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* 自定义退出动画 */
.slide-from-bottom-leave-active {
  animation: slide-from-bottom-leave 0.5s ease-in;
}

@keyframes slide-from-bottom-leave {
  from {
    transform: translateY(0);
    opacity: 1;
  }

  to {
    transform: translateY(100%);
    opacity: 0;
  }
}

/* 图片淡入淡出过渡（自然的加速度） */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@supports (bottom: constant(safe-area-inset-bottom)) or (bottom: env(safe-area-inset-bottom)) {
  .safe-padding {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    padding-top: 0.45rem;
    transition: padding-bottom 0.3s ease;
  }
}
</style>
